//  <FileHeader xmlns="http://www.gordic.cz/shared/file-header/v_1.0.0.0">
//    <Name>        Gordic.Adm.WebControls.SeznamEleServerDesigner.ts             </Name>
//    <Description>                                                             </Description>
//    <Author>      FFIALA                                                      </Author>
//    <Copyright>   � GORDIC spol. s r. o. 1993-2019                            </Copyright>
//    <Created>     2019-04-17                                                  </Created>
//  </FileHeader>

//This source code was auto-generated by ADT03-Generator, Version=482.67.X1
//AdtGeneratorConfig:[ V1:(server_name,nazev,poznamka,ldb,priorita,dat_zmena,server_name_fyz) V2:(typ_srv,aktivita,zmenu_prov,typ_eps) K1: () K2: (f_wflsser_typ_eps,f_wflsser_typ_srv) ]


/// <reference path="../../Base/SeznamBase.ts" />

namespace Gordic.Adm.WebControls {

    /**
     * SeznamZastupDesigner
     * 
     * @author FFIALA
     * @since 482.1.0.119
     */
    export class SeznamEleServerDesigner extends SeznamBase {

        /** z detail okna p�edan� atribut pro filtr seznamu */
            /** PK - server_name */
            public server_name: string;

        /** isl view gridu */
        view: Gordic.Isl.View<Gordic.AdmIsl.Interface.GEleServerDto>;

        /** vytvo�it form�t seznamu - definice sloupc�, napdpis�, ���ek atd... */
        static createGridFormat(that: GContentType<SeznamEleServerDesigner>): Gordic.Data.GridFormat {

            var columnsDefinition = this.createGridFormatBase(that);

            columnsDefinition
                .addTextColumn({
                                    name: "server_name",
                                    caption: "jres:30028705", //RC 30028705 : Jm�no serveru elektronick�ho �lo�i�t�
                                    width: 300,
                                    fragment: ""
                })
                .addTextColumn({
                                    name: "nazev",
                                    caption: "jres:30028701", //RC 30028701 : N�zev serveru
                                    width: 300,
                                    fragment: ""
                })
                .addTextColumn({
                                    name: "poznamka",
                                    caption: "jres:29930689", //RC 29930689 : Pozn�mka
                                    width: 300,
                                    fragment: ""
                })
                .addTextColumn({
                                    name: "typ_srv_txt",
                                    caption: "jres:30028709", //RC 30028709 : Typ �lo�i�t�
                                    width: 300,
                                    fragment: ""
                })
                .addTextColumn({
                                    name: "login",
                                    caption: "jres:30028700", //RC 30028700 : Login k serveru
                                    width: 300,
                                    fragment: ""
                })
                .addNumberColumn({
                                    name: "priorita",
                                    caption: "jres:30028704", //RC 30028704 : Priorita serveru
                                    width: 150,
                                    fragment: ""
                })
                .addTextColumn({
                                    name: "aktivita_txt",
                                    caption: "jres:29924152", //RC 29924152 : Aktivita
                                    width: 300,
                                    fragment: ""
                })
                .addDateTimeColumn({
                                    name: "dat_zmena",
                                    caption: "jres:29930674", //RC 29930674 : Zm�n�no
                                    width: 150,
                                    fragment: ""
                })
                .addTextColumn({
                                    name: "zmenu_prov_txt",
                                    caption: "jres:29930694", //RC 29930694 : Zm�nil
                                    width: 300,
                                    fragment: ""
                })
                .addTextColumn({
                                    name: "typ_eps_txt",
                                    caption: "jres:30028708", //RC 30028708 : Typ WWW
                                    width: 300,
                                    fragment: ""
                })
                .addTextColumn({
                                    name: "server_name_fyz",
                                    caption: "jres:30028706", //RC 30028706 : Fyzick� jm�no serveru elektronick�ho �lo�i�t�
                                    width: 300,
                                    fragment: ""
                })

            return columnsDefinition;
        } // createGridFormat

        /** vytvo�it formul�� filtru - panel */
        static createFilter(that: GContentType<SeznamEleServerDesigner>): JQuery<HTMLElement> {
            // vytvorim form a na nem policka
            let v_form = this.createFilterForm(that);
            // vytvorim panel a umistim jej do hlavniho DIVu
            let v_filter = SeznamBase.createFilterBase(that, v_form, true);

            //v_filter.gfilterpanel("applyFilter");         // toto vede k okam�it�mu na�ten� dat do seznamu podle nastaven�ho filtru

            return (v_filter);
        } // createFilter

        /** vytvo�it formul�� filtru - vytvo�� tam filtra�n� pol��ka */
        static createFilterForm(that: GContentType<SeznamEleServerDesigner>): Forms.Form {

            // vytvo��m form
            var v_filterForm = SeznamBase.createFilterFormBase(that);

            // p�id�m do n�j pol��ka

            return v_filterForm;
        } // createFilterForm

        /**
         * SeznamEleServerDesignerInit
         * 
         * @param {GContentType<SeznamEleServerDesigner>} that
         */
        static SeznamEleServerDesignerInit(that: GContentType<SeznamEleServerDesigner>) {

            that.gridSearchColumns = "server_name,nazev,poznamka,typ_srv_txt,ldb,priorita,aktivita_txt,dat_zmena,zmenu_prov_txt,typ_eps_txt,server_name_fyz".split(",");

            SeznamBase.SeznamBaseInit(that as GContentType<SeznamBase>);

            that.filter = this.createFilter(that);

            that.gridFormat = this.createGridFormat(that);
            
            that.view = new Gordic.Isl.View(that.isl.EleServer.list(), { filterPanel: that.filter, startEmpty: false, });       // propojen� ovl�dac�ho prvku gridu se zdrojem dat - a s filter panelem

        } // SeznamEleServerDesignerInit
    }
}
